import {Component, computed, input} from '@angular/core';
import {Dice1Icon, Dice3Icon, Dice6Icon, DicesIcon, LucideAngularModule, SquareDashedIcon} from 'lucide-angular';
import {ActivityScheduleLevel} from '@domain/activity/schedule/schedule.dto';

@Component({
  selector: 'app-schedule-level-icon',
  imports: [
    LucideAngularModule
  ],
  templateUrl: './schedule-level-icon.component.html'
})
export class ScheduleLevelIconComponent {

  public readonly level = input.required<ActivityScheduleLevel | null | undefined>();
  public readonly icon = computed(() => {
    const level = this.level();
    return level ? this.icons?.[level] : this.noLevelIcon;
  });

  private readonly noLevelIcon = SquareDashedIcon;

  private readonly icons = {
    [ActivityScheduleLevel.All]: DicesIcon,
    [ActivityScheduleLevel.Beginner]: Dice1Icon,
    [ActivityScheduleLevel.Intermediate]: Dice3Icon,
    [ActivityScheduleLevel.Advanced]: Dice6Icon
  };
}
